export default "__VITE_ASSET__c415fd3e__"